import { getConfig } from '@linqx/config';
import { Configuration, type HTTPHeaders, type Middleware as GeneratedMiddleware } from './generated/runtime';
import { createAuthMiddleware, type AuthMiddlewareOptions } from './middleware';

export interface CreateApiOptions extends AuthMiddlewareOptions {
  extraHeaders?: HTTPHeaders;
  extraMiddleware?: GeneratedMiddleware[];
}

export interface ApiConfiguration {
  basePath: string;
  headers: HTTPHeaders;
  middleware: GeneratedMiddleware[];
}

export interface BaseApiClass<T> {
  new (config: Configuration): T;
}

export const createApiConfig = (options: CreateApiOptions = {}): Configuration => {
  const { extraHeaders = {}, extraMiddleware = [], ...authOptions } = options;
  const config = getConfig();

  return new Configuration({
    basePath: config.apiHost,
    headers: extraHeaders,
    middleware: [createAuthMiddleware(authOptions), ...extraMiddleware],
  });
};

export const createApi = <T>(
  ApiClass: BaseApiClass<T>,
  options: CreateApiOptions = {}
): T => {
  const config = createApiConfig(options);
  return new ApiClass(config);
};
